"use strict";

var _regeneratorRuntime = require("/home/corey/wisetack/clients/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.api = exports.API_REQUEST_STARTED = exports.API_REQUEST_ENDED = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _Log = _interopRequireDefault(require("./Log"));

var _format = require("./format");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var API_REQUEST_STARTED = 'API_REQUEST_STARTED';
exports.API_REQUEST_STARTED = API_REQUEST_STARTED;
var API_REQUEST_ENDED = 'API_REQUEST_ENDED';
exports.API_REQUEST_ENDED = API_REQUEST_ENDED;

var sleep = function sleep(delay) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, delay);
  });
};

var api = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(method, path, data, dispatch, skipLoading, requestId) {
    var url, jobUrl, headers, params, timeout, delays, token, bb, response, jwt, _token, jobId, iterator, _iterator$next, done, value, jobResponse, errorMessage;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = "".concat(process.env.REACT_APP_API_URL).concat(path);
            jobUrl = "".concat(process.env.REACT_APP_API_URL, "/jobs/");
            headers = {};
            params = {};
            timeout = 60000;
            delays = [2000, 2000, 5000, 5000, 5000, 10000, 10000, 10000, 20000, 20000, 20000, 20000, 20000, 20000, 60000, 60000, 60000, 60000];
            token = sessionStorage.getItem("wisetack:ba:token");

            if (token) {
              headers['Authorization'] = token;
            }

            if (window.ioGetBlackbox) {
              bb = window.ioGetBlackbox();

              if (bb && bb.finished) {
                headers["X-IO-Blackbox"] = bb.blackbox;
              }
            } else {//This means script was blocked. Here add Amplitude event or something to track success
            }

            _context.prev = 9;

            if (!skipLoading) {
              dispatch({
                type: API_REQUEST_STARTED,
                payload: {
                  requestId: requestId
                }
              });
            }

            _context.next = 13;
            return (0, _axios["default"])({
              method: method,
              url: url,
              data: data,
              params: params,
              headers: headers,
              timeout: timeout
            });

          case 13:
            response = _context.sent;

            _Log["default"].info(response, "API");

            if (!response.data.errorMessage) {
              _context.next = 17;
              break;
            }

            throw new Error(response.data.errorMessage);

          case 17:
            jwt = null;

            if (response.headers && response.headers['x-wisetack-token']) {
              _token = response.headers['x-wisetack-token'];
              sessionStorage.setItem("wisetack:ba:token", _token);
              jwt = (0, _format.decodeToken)(_token);
            }

            if (!(response.status === 202 && response.data && response.data.jobId)) {
              _context.next = 43;
              break;
            }

            jobId = response.data.jobId;
            iterator = delays[Symbol.iterator]();

          case 22:
            if (!true) {
              _context.next = 41;
              break;
            }

            _iterator$next = iterator.next(), done = _iterator$next.done, value = _iterator$next.value;

            if (done) {
              _context.next = 38;
              break;
            }

            _context.next = 27;
            return sleep(value);

          case 27:
            _context.next = 29;
            return (0, _axios["default"])({
              method: 'GET',
              url: jobUrl + jobId,
              params: params,
              headers: headers,
              timeout: timeout
            });

          case 29:
            jobResponse = _context.sent;

            _Log["default"].info(jobResponse, "Requesting job ".concat(jobId, " result."));

            if (!jobResponse.data.errorMessage) {
              _context.next = 33;
              break;
            }

            throw new Error(jobResponse.data.errorMessage);

          case 33:
            if (!(jobResponse.status !== 202)) {
              _context.next = 36;
              break;
            }

            data = jobResponse.data;
            return _context.abrupt("break", 41);

          case 36:
            _context.next = 39;
            break;

          case 38:
            throw new Error("Job [".concat(jobId, "] timeout reached."));

          case 39:
            _context.next = 22;
            break;

          case 41:
            _context.next = 44;
            break;

          case 43:
            data = response.data;

          case 44:
            if (jwt && !data.jwt) {
              data.jwt = jwt;
            }

            _context.next = 55;
            break;

          case 47:
            _context.prev = 47;
            _context.t0 = _context["catch"](9);

            if (!_axios["default"].isCancel(_context.t0)) {
              _context.next = 52;
              break;
            }

            _context.next = 55;
            break;

          case 52:
            errorMessage = _context.t0.message;

            if (_context.t0.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              _Log["default"].warn(_context.t0.response.data, "API error response data");

              if ((0, _format.isString)(_context.t0.response.data)) {
                errorMessage = _context.t0.response.data;
              } else if ((0, _format.isString)(_context.t0.response.data.message)) {
                errorMessage = _context.t0.response.data.message;
              } else if ((0, _format.isString)(_context.t0.response.data.errorMessage)) {
                errorMessage = _context.t0.response.data.errorMessage;
              } else if ((0, _format.isObject)(_context.t0.response.data.errorMessage) && (0, _format.isString)(_context.t0.response.data.errorMessage.message)) {
                errorMessage = _context.t0.response.data.errorMessage.message;
              } else {
                errorMessage = JSON.stringify(_context.t0.response, null, 2);
              }
            }

            throw new Error(errorMessage);

          case 55:
            _context.prev = 55;
            dispatch({
              type: API_REQUEST_ENDED,
              payload: {
                requestId: requestId
              }
            });
            return _context.finish(55);

          case 58:
            return _context.abrupt("return", data);

          case 59:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 47, 55, 58]]);
  }));

  return function api(_x, _x2, _x3, _x4, _x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();

exports.api = api;